import { render } from "./noData.vue?vue&type=template&id=a3e74bf4&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"

import "./noData.vue?vue&type=style&index=0&id=a3e74bf4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3e74bf4"]])

export default __exports__